import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ManageUserRoleWidget from '../../../../widgets/manageUserRole/ManageUserRoleWidget'
import { getManageUserRoleGroup } from '../../../../redux/actions/manageAccess'

export default function ManageUserRole() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  const mockSchema = {
    header: 'จัดการสิทธ์โครงการย่อย',
    // subHeader: 'โครงการ 65-00012-01 : เด็กฉลาด ขอเบิกงวดเงิน',
    subHeader: '',
    form: {
      title: 'จัดการสิทธ์',
      projectCode: {
        label: 'รหัสโครงการ',
        name: 'projectCode',
        value: null,
      },
      values: [
        {
          projectVersion: '1111-1111-1111-111',
          projectCode: '67-10009-01',
          projectName: 'โครงการ A',
          projectStatus: '1111-1111-1111-111',
          projectStatusName: 'ดำเนินการ',
          coordinatorName: 'นาย Aa Bb',
          leaderManageName: 'นางสาว เอบี',
          coordinatorSuportorName: 'นายซี',
          evaluationTeam: '',
          financeOfficer: 'นาย B',
          granteeName: 'นาย G',
        },
        {
          projectVersion: '2222-2222-2222-222',
          projectCode: '67-10009-02',
          projectName: 'โครงการ A',
          projectStatus: '2222-2222-2222-222',
          projectStatusName: 'ดำเนินการ',
          coordinatorName: 'นาย Aa Bb',
          leaderManageName: 'นางสาว เอบี',
          coordinatorSuportorName: 'นายซี',
          evaluationTeam: '',
          financeOfficer: 'นาย B',
          granteeName: 'นาย G',
        },
        {
          projectVersion: '3333-3333-3333-333',
          projectCode: '67-10009-03',
          projectName: 'โครงการ A',
          projectStatus: '3333-3333-3333-333',
          projectStatusName: 'ดำเนินการ',
          coordinatorName: 'นาย Aa Bb',
          leaderManageName: 'นางสาว เอบี',
          coordinatorSuportorName: 'นายซี',
          evaluationTeam: '',
          financeOfficer: 'นาย B',
          granteeName: 'นาย G',
        },
      ],
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManageUserRoleGroup('', 10, 1)
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectReport>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        <ManageUserRoleWidget schema={schema.form} />
      </SidebarProposal>
    </>
  )
}
